var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, OnDestroy } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { SharedRoutes } from "shared/lib/common/enums";
import { TranslateService, UtilsService, P4mService, AdminService, RoutingService } from "shared/lib/common/services";
import { ConfigService } from "shared/lib/common/services";
var SuccessPage = /** @class */ (function () {
    function SuccessPage(routing, modal, p4m, admin, config, utils, translate) {
        this.routing = routing;
        this.modal = modal;
        this.p4m = p4m;
        this.admin = admin;
        this.config = config;
        this.utils = utils;
        this.translate = translate;
    }
    SuccessPage.prototype.ngOnInit = function () {
        this.loading = true;
        this.setTimeout();
    };
    SuccessPage.prototype.ngOnDestroy = function () {
        clearTimeout(this.timeout);
    };
    SuccessPage.prototype.ionViewDidEnter = function () {
        return __awaiter(this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.p4m.readAccountBalance({
                            keyCode: this.keyCode,
                            idType: this.idType,
                            apiKey: this.admin.getApiKey(),
                            clientId: this.config.getMountingConfig().clientId,
                        })];
                    case 1:
                        resp = _a.sent();
                        if (resp.ok === true)
                            this.totalPoints = resp.response.points;
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    SuccessPage.prototype.success = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modal.dismiss()];
                    case 1:
                        _a.sent();
                        this.routing.goForward([SharedRoutes.screenSaver]);
                        return [2 /*return*/];
                }
            });
        });
    };
    SuccessPage.prototype.setTimeout = function () {
        var _this = this;
        this.timeout = setTimeout(function () {
            clearTimeout(_this.timeout);
            _this.success();
        }, 20000);
    };
    return SuccessPage;
}());
export { SuccessPage };
